var angular = require('angular');
angular.module('pitch.search')
.controller('AdvancedfiltersModalCtrl', function($scope, SearchConfig, Territory, $state) {
    Territory.query({
        hasCharts: true
    }, function(r) {
        $scope.chartTerritories = r;
    });

    $scope.searchModel = SearchConfig.getModel();

    //cast
    if ($scope.searchModel.chartPosition) {
        $scope.searchModel.chartPosition = $scope.searchModel.chartPosition + "";
    }

    $scope.search = function(terms) {
        //this prevents a bug in ui-router trying to naviagate to a route with a value that is null instead of undefined
        angular.forEach(terms, function(v, k) {
            if (null === v || "" === v) {
                terms[k] = undefined;
            }
        });

        $state.go('search', terms);
        $scope.$close();
    };
});



// WEBPACK FOOTER //
// ./src/SearchClientBundle/Resources/js/angular/controllers/AdvancedFiltersModalCtrl.js